import { createFileRoute, useParams } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { InstalledAppsPage } from "./-installed_apps/installedAppsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/apps/installed/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });
  useBreadCrumbs([{ title: "Installed Apps", link: `/${datasetSlug}/apps/installed` }]);
  return <InstalledAppsPage />;
}
